import { render, staticRenderFns } from "./whiteGdids.vue?vue&type=template&id=3c8ef9eb&"
import script from "./whiteGdids.vue?vue&type=script&lang=js&"
export * from "./whiteGdids.vue?vue&type=script&lang=js&"
import style0 from "./whiteGdids.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports